
import React from 'react';
import { motion } from 'framer-motion';
import { Image } from '@/components/ui/image';
import { cn } from '@/lib/utils';
import { logoAnimation } from './animations';

export const HeaderLogo: React.FC = () => {
  const handleLogoClick = () => {
    window.open('https://lhp2005.vercel.app', '_blank');
  };

  return (
    <motion.div 
      className="flex-shrink-0"
      initial="initial"
      animate="animate"
      variants={logoAnimation}
    >
      <div 
        className={cn(
          "relative bg-white shadow-lg",
          "w-24 h-24 md:w-32 md:h-32", // Smaller on desktop
          "flex items-center justify-center",
          "border-3 border-amber-400 md:border-4",
          "rounded-lg overflow-hidden",
          "cursor-pointer transition-transform hover:scale-105"
        )}
        onClick={handleLogoClick}
        role="link"
        aria-label="Truy cập trang LHP 2005"
        title="Mở trang LHP 2005"
      >
        <Image 
          src="/lovable-uploads/46f6437f-3898-4fda-a4e1-d9b6194ac522.png"
          alt="THPT Chuyên Lê Hồng Phong Logo 2025"
          className="w-[92%] h-[92%] object-contain"
          fallback={
            <div className="w-full h-full flex items-center justify-center bg-gray-100">
              <span className="text-blue-500 font-bold text-sm">LHP</span>
            </div>
          }
        />
        <div className="absolute -right-1 -bottom-1 w-8 h-8 md:w-10 md:h-10 bg-amber-400 rounded-full flex items-center justify-center shadow-md">
          <span className="text-blue-900 font-bold text-xs md:text-sm">2025</span>
        </div>
      </div>
    </motion.div>
  );
};
